import React from 'react';
import { cn } from '../index';

const variants = {
  primary: 'bg-[var(--primary)] text-[var(--primary-fg)] hover:opacity-90 shadow-sm',
  secondary: 'bg-[var(--muted)] text-[var(--card-fg)] border border-[var(--border)] hover:bg-[var(--bg-subtle)]',
  ghost: 'text-[var(--fg-muted)] hover:bg-[var(--muted)] hover:text-[var(--fg)]',
  destructive: 'bg-[var(--destructive)] text-[var(--destructive-fg)] hover:opacity-90',
  outline: 'border border-[var(--border)] text-[var(--fg)] bg-transparent hover:bg-[var(--muted)]',
} as const;

const sizes = {
  sm: 'h-8 px-3 text-xs gap-1.5',
  md: 'h-9 px-4 text-sm gap-2',
  lg: 'h-10 px-5 text-sm gap-2',
  icon: 'h-9 w-9',
} as const;

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    />
  ),
);
Button.displayName = 'Button';
